import { createCn } from "cnfast";
import { twMergeConfig } from "./tailwind-merge.js";
const cn = createCn(twMergeConfig);
export { cn };
